var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#224A91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 66.3161C56.7727 66.3161 66.3161 56.7727 66.3161 45.0004C66.3161 33.228 56.7727 23.6846 45.0004 23.6846C33.228 23.6846 23.6846 33.228 23.6846 45.0004C23.6846 56.7727 33.228 66.3161 45.0004 66.3161Z",
    stroke: "white",
    strokeWidth: 3.55263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6714 38.5317C39.6714 37.5144 39.6714 37.0057 39.884 36.7217C40.0693 36.4742 40.3529 36.3194 40.6613 36.2973C41.0151 36.2721 41.443 36.5471 42.2988 37.0973L52.3611 43.5659C53.1037 44.0433 53.475 44.282 53.6033 44.5855C53.7153 44.8507 53.7153 45.15 53.6033 45.4152C53.475 45.7187 53.1037 45.9574 52.3611 46.4348L42.2988 52.9034C41.443 53.4536 41.0151 53.7287 40.6613 53.7034C40.3529 53.6814 40.0693 53.5265 39.884 53.279C39.6714 52.995 39.6714 52.4864 39.6714 51.469V38.5317Z",
    stroke: "white",
    strokeWidth: 3.55263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.2105d6bed1e23ca8deedb0593a22410d.svg";
export { ForwardRef as ReactComponent };